import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported as isAnalyticsSupported } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Vite exposes env via import.meta.env; envPrefix keeps REACT_APP_* names.
const env = import.meta.env;
window.env = env;

let config = Object.filter(env, (v, k) => k.includes("REACT_APP_FB_"));
config = Object.entries(config)
  .map((arr) => {
    arr[0] = arr[0].split("REACT_APP_FB_").join("");
    return arr;
  })
  .reduce((o, v) => {
    o[v[0]] = v[1];
    return o;
  }, {});

const firebaseConfig = {
  apiKey: config.apiKey,
  authDomain: config.authDomain,
  databaseURL: config.databaseURL,
  projectId: config.projectId,
  storageBucket: config.storageBucket,
  messagingSenderId: config.messagingSenderId,
  appId: config.appId,
  measurementId: config.measurementId,
};

// Skip init when REACT_APP_FB_* is not configured (same empty-config case as CRA).
let firebaseApp;
if (firebaseConfig.apiKey) {
  firebaseApp = initializeApp(firebaseConfig);

  // getAuth/getFirestore require a live config; analytics also needs
  // browser support (SSR/older browsers can lack the APIs it needs).
  window.firebase = {
    app: firebaseApp,
    auth: getAuth(firebaseApp),
    firestore: getFirestore(firebaseApp),
  };

  isAnalyticsSupported().then((supported) => {
    if (supported) {
      window.firebase.analytics = getAnalytics(firebaseApp);
    }
  });
} else {
  window.firebase = null;
}
